const currentState = {
  authData:
    window.location.hostname === "localhost"
      ? {
          authenticated: false,
          isAdmin: null,
          companyCode: null,
          companyId: null,
          companyName: null,
          userId: null,
          userName: null,
          userEmail: null,
          accessToken: null,
          tokenExpiry: null,
          tokenExpiryTminus: null,
          refreshToken: null,
          isICT: null,
          loginLogId: null,
          otherLoggedInUser: null,
          tokenIsValid: false,
          loginName: null,
        }
      : {
          authenticated: false,
          isAdmin: false,
          companyCode: null,
          companyId: null,
          companyName: null,
          userId: null,
          userName: null,
          userEmail: null,
          accessToken: null,
          tokenExpiry: null,
          tokenExpiryTminus: null,
          refreshToken: null,
          isICT: null,
          loginLogId: null,
          otherLoggedInUser: null,
          tokenIsValid: false,
          loginName: null,
        },
  userIsBlocked: false,
  avatarURI: {
    URI: null,
    error: false,
  },
};

const reducer = (state = currentState, action) => {
  switch (action.type) {
    case "SIGN_IN": {
      const auth = { ...state.authData };

      auth.authenticated = action.payload.authenticated;
      auth.isAdmin = action.payload.isAdmin;
      auth.companyCode = action.payload.companyCode;
      auth.companyId = action.payload.companyId;
      auth.companyName = action.payload.companyName;
      auth.userId = action.payload.userId;
      auth.userName = action.payload.userName;
      auth.userEmail = action.payload.userEmail;
      auth.accessToken = action.payload.accessToken;
      auth.tokenExpiry = action.payload.tokenExpiry;
      auth.tokenExpiryTminus = action.payload.tokenExpiryTminus;
      auth.refreshToken = action.payload.refreshToken;
      auth.isICT = action.payload.isICT;
      auth.loginLogId = action.payload.loginLogId;
      auth.tokenIsValid = true;
      auth.loginName = action.payload.loginName;

      return {
        ...state,
        authData: auth,
      };
    }
    case "SET_USERNAME_AND_COMPANY_CODE": {
      const auth = { ...state.authData };
      auth.companyCode = action.payload.companyCode;
      auth.userName = action.payload.userName;
      return {
        ...state,
        authData: auth,
      };
    }

    case "OTHER_LOGGED_IN_USER": {
      const auth = { ...state.authData };
      auth.otherLoggedInUser = action.payload;
      auth.tokenIsValid = false;
      return {
        ...state,
        authData: auth,
      };
    }
    case "SET_TOKEN_VALIDITY": {
      const auth = { ...state.authData };
      auth.tokenIsValid = true;
      return {
        ...state,
        authData: auth,
      };
    }
    case "SET_TOKEN_INVALID": {
      const auth = { ...state.authData };
      auth.tokenIsValid = false;
      return {
        ...state,
        authData: auth,
      };
    }
    case "SET_USER_BLOCKED":
      return {
        ...state,
        userIsBlocked: true,
      };
    case "SET_AVATAR_URI": {
      const avatarURI = { ...state.avatarURI };
      const urlCreator = window.URL || window.webkitURL;
      if (action.payload instanceof Blob) {
        const URI = urlCreator.createObjectURL(action.payload);
        avatarURI.URI = URI;
      }

      return {
        ...state,
        avatarURI: avatarURI,
      };
    }
    case "SET_AVATAR_URI_ERROR": {
      const avatarURI = { ...state.avatarURI };
      avatarURI.error = true;

      return {
        ...state,
        avatarURI: avatarURI,
      };
    }
    case "RENEW_LEASE": {
      const auth = { ...state.authData };

      auth.tokenExpiry = action.payload.tokenExpiry;
      auth.tokenExpiryTminus = action.payload.tokenExpiryTminus;
      auth.tokenIsValid = true;

      return {
        ...state,
        authData: auth,
      };
    }
    case "SWITCH_COMPANY": {
      const auth = { ...state.authData };

      auth.companyId = action.payload.id;
      auth.companyName = action.payload.name;

      return {
        ...state,
        authData: auth,
      };
    }
    case "SIGN_OUT": {
      const auth = { ...state.authData };
      auth.authenticated = false;
      auth.isAdmin = null;
      auth.companyCode = null;
      auth.companyId = null;
      auth.companyName = null;
      auth.userId = null;
      auth.userName = null;
      auth.userEmail = null;
      auth.accessToken = null;
      auth.tokenExpiry = null;
      auth.tokenExpiryTminus = null;
      auth.refreshToken = null;
      auth.loginLogId = null;
      auth.otherLoggedInUser = null;
      auth.tokenIsValid = false;
      auth.loginName = null;
      return {
        ...state,
        authData: auth,
      };
    }
    default:
      return state;
  }
};

export default reducer;
